import dayjs from 'dayjs';
import type { Options } from 'highcharts';
import type { TGetDistributionCostByMonthsRes } from 'api/swagger';

export const distributionCostChartHighchartsOptions = (series: TGetDistributionCostByMonthsRes['series']): Options => {
  const months = Array.from(new Set([...series.distributionCost, ...series.totalLdm].map(({ x }) => x))).sort();
  const costs = new Map(series.distributionCost.map(({ x, y }) => [x, y]));
  const loads = new Map(series.totalLdm.map(({ x, y }) => [x, y]));

  return {
    chart: { type: 'column' },
    title: { text: undefined },
    credits: { enabled: false },
    xAxis: {
      categories: months.map((month) => dayjs(`${month}-01`).format('MMM YYYY')),
      crosshair: true,
    },
    yAxis: [
      { min: 0, title: { text: 'EUR' } },
      { min: 0, title: { text: 'LDM' }, opposite: true },
    ],
    tooltip: { shared: true },
    series: [
      {
        type: 'column',
        name: 'Distribution cost',
        data: months.map((month) => costs.get(month) ?? null),
        yAxis: 0,
        tooltip: { valueSuffix: ' EUR', valueDecimals: 2 },
      },
      {
        type: 'column',
        name: 'Total LDM',
        data: months.map((month) => loads.get(month) ?? null),
        yAxis: 1,
        tooltip: { valueSuffix: ' LDM', valueDecimals: 2 },
      },
    ],
  };
};
